import { render, staticRenderFns } from "./home_article.vue?vue&type=template&id=11bc665f&scoped=true"
import script from "./home_article.vue?vue&type=script&lang=js"
export * from "./home_article.vue?vue&type=script&lang=js"
import style0 from "./home_article.vue?vue&type=style&index=0&id=11bc665f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc665f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bc665f')) {
      api.createRecord('11bc665f', component.options)
    } else {
      api.reload('11bc665f', component.options)
    }
    module.hot.accept("./home_article.vue?vue&type=template&id=11bc665f&scoped=true", function () {
      api.rerender('11bc665f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_article.vue"
export default component.exports